class History {
  static historyInstance = null;

  static push(page) {
    History.historyInstance.push(page);
  }
}

export default History;
